export const DEFAULT_VIQEO_PLAYER_ID = 2349;
export const DEFAULT_VIQEO_PROFILE_ID = 10099;

export const IS_NEW_YEAR_LOGO = false;

// Октябрьский логотип раздела «Здоровье», с 1 ноября 2026 (МСК) возвращается обычный
const HEALTH_OCTOBER_2026_LOGO_END = Date.parse('2026-11-01T00:00:00+03:00');
export const isHealthOctober2026Logo = (): boolean => Date.now() < HEALTH_OCTOBER_2026_LOGO_END;
